export default "__VITE_ASSET__2684b3b5__"